module.exports = "module.exports = __webpack_public_path__ + \"static/media/header.aa110522.template\";"